



























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TradesApi, Trade } from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';

@Component({
  components: {},
  computed: mapGetters({
    currentUser: 'currentUser',
    api: 'tradesApi'
  })
})
export default class TradePicker extends Vue {
  private currentUser!: User;
  private api!: TradesApi;

  private allTrades!: Trade[];
  private loadingTrades = true;
  private pageSize = 25;
  private allOption: Trade = { tradeName: 'All' };

  @Prop({ required: false, default: false })
  private required?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: 'Trade' })
  private labelOverride?: string;

  @Prop({ required: false, default: false, type: Boolean })
  private hideLabel?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideTradesWithoutJobTypes?: boolean;

  @Prop({ required: false, default: undefined })
  private kindFilter!: string;

  /*
  When true, will append the "All" option to the top of the Trades list.
  When "All" is selected, all Job Types for all Trades should be available in the Job Type Picker.
  */
  @Prop({ required: false, default: false, type: Boolean })
  private includeAllOption!: boolean;

  /*
  When true, will filter the list to the current workers trade list only.
  Ex: workers should only be able to filter to their own trades, but could create an order for a different trade.
  */
  @Prop({ required: false, default: false, type: Boolean })
  private dontFilterWorkerTrades!: boolean;

  get getValue() {
    return this.value;
  }

  private data() {
    // this lets the undefined allTrades! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      allTrades: undefined
    };
  }

  private get filteredTrades(): Trade[] {
    if (this.allTrades) {
      let tradesArray;
      if (this.hideTradesWithoutJobTypes || this.kindFilter) {
        tradesArray = this.allTrades.filter(
          (t) =>
            t.jobTypes &&
            // remove trades that do not have any job types
            ((this.hideTradesWithoutJobTypes && t.jobTypes.length) ||
              // remove trades where none of its job types match the kind filter
              (this.kindFilter &&
                t.jobTypes.filter((j) => j.kindFilter === this.kindFilter)
                  .length))
        );
      } else {
        tradesArray = [...this.allTrades];
      }

      if (
        (this.currentUser.profile.candoq &&
          this.currentUser.profile.candoq.indexOf('View Orders: All') >= 0) ||
        this.dontFilterWorkerTrades ||
        this.currentUser.profile.interface === 'Requester'
      ) {
        return tradesArray || [];
      } else {
        return tradesArray.filter(
          (f) => this.currentUser.profile.Trades.indexOf(f.tradeName) >= 0
        );
      }
    }
    return [];
  }

  get Trades(): Trade[] {
    const trades = [...this.filteredTrades];
    if (this.includeAllOption) {
      trades.unshift(this.allOption);
    }
    return trades;
  }

  @Watch('propertyId', { immediate: true })
  private async loadTrades() {
    this.loadingTrades = true;
    this.allTrades = [];

    var pagedTradesIndex = 0;
    do {
      var pagedTrades = await this.api.queryTrades({
        propertyId: this.propertyId,
        includeJobTypes: true,
        sortColumn: 'tradeName',
        sortDirection: 'ascend',
        take: this.pageSize,
        skip: pagedTradesIndex * this.pageSize + 1
      });
      if (pagedTrades.data) {
        this.allTrades.push(...pagedTrades.data);
      }
      pagedTradesIndex++;
    } while (
      pagedTrades &&
      pagedTrades.pagination &&
      pagedTrades.pagination.totalPages &&
      pagedTrades.pagination.pageNumber &&
      pagedTrades.pagination.pageNumber !== pagedTrades.pagination.totalPages
    );

    this.loadingTrades = false;
  }

  public tradeListContains(trade: string) {
    let found = false;
    this.Trades.forEach((element) => {
      if (element.tradeName === trade) {
        found = true;
      }
    });
    return found;
  }
}
